<template lang="pug">
#solicitar-laudos
    BaseHeader(
        titulo='Novo Relatório de Compartilhamento de Dados',
        icon='el-icon-plus',
        btnTexto='Adicionar território',
        :exibeBotao='true',
        @btnHeaderClicado='changeShowModalAddTerritorios'
    )

    .view-container
        .acoes
            el-button(size='small', @click='$router.go(-1)')
                | Voltar

            el-button(
                v-if='Object.keys(territorios).length > 0 && finalizar',
                size='small',
                type='primary',
                icon='el-icon-check',
                @click='solicitarRelatorios'
            )
                | Finalizar
            el-button(
                v-else-if='Object.keys(territorios).length > 0',
                size='small',
                type='primary',
                icon='el-icon-check',
                @click='validacaoIcorreta'
            )
                | Finalizar

        .territorios
            header.m-titulo
                h2 Territórios adicionados

            main(v-if='Object.keys(territorios).length > 0')
                CardDadosTerritorio.mb-2(
                    v-for='(id, index) in Object.keys(territorios)',
                    :territorio='territorios[id]',
                    :index='index',
                    :key='`${territorios[id].nome}_${id}`',
                    :valido='cardValido[index]',
                    :culturas='culturas',
                    :produtos='produtos',
                    :unidadesMedida='unidadesMedida',
                    @removerTerritorio='removerTerritorio',
                    @getValidacao='setValidacao',
                    @getDados='setDados'
                )

            main.sem-territorios(v-else)
                el-empty(description='Você ainda não possui Territórios.')
                    el-button(
                        type='primary',
                        @click='changeShowModalAddTerritorios'
                    ) Adicionar território

    el-dialog.add-territorio(
        title='Selecione um ou mais territórios para solicitação de relatórios',
        :visible.sync='showModalAddTerritorios',
        close='changeShowModalAddTerritorios'
    )
        SelecionarTerritorio(
            :selecionados='territoriosSelecionados',
            @getIdsTerritoriosSelecionados='addTerritorios'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import CardDadosTerritorio from '@/components/compartilhamentoDados/CardDadosTerritorio';
// import SelecionarTerritorio from '@/components/laudos/SelecionarTerritorio';
import SelecionarTerritorio from '@/components/compartilhamentoDados/SelecionarTerritorio.vue';

import TerritorioService from '@/services/TerritorioService';
import CompartilhamentoDadosService from '@/services/CompartilhamentoDadosService';

export default {
    name: 'PageSolicitarRelatorioCompartilhamentoDados',

    components: {
        BaseHeader,
        CardDadosTerritorio,
        SelecionarTerritorio
    },

    data() {
        return {
            idsTerritoriosSelecionados: [],
            territoriosSelecionados: [],
            culturas: [],
            dados: {},
            territorios: {},
            cardValido: {},
            showModalAddTerritorios: false,
            finalizar: false,
            produtos: [],
            unidadesMedida: []
        };
    },

    async mounted() {
        this.idsTerritoriosSelecionados = this.$route.params.idsTerritorio;
        await this.getTerritorios();
        this.buscarProdutos();
        this.buscarUnidadesMedida();
    },

    methods: {
        async buscarProdutos() {
            await TerritorioService.findProdutos().then(({ data }) => {
                this.produtos = data;
            });
        },

        async buscarUnidadesMedida() {
            await TerritorioService.findUnidadesMedida().then(({ data }) => {
                this.unidadesMedida = data;
            });
        },

        getTerritorios() {
            const territorios = {
                territoriosIds: this.idsTerritoriosSelecionados
            };

            TerritorioService.solicitacaoLaudo(territorios)
                .then(({ data }) => {
                    this.territorios = {};

                    for (let i = 0; i < data.length; i += 1) {
                        let id = data[i].id;

                        this.territorios[id] = data[i];
                        this.cardValido[id] = this.cardValido[id] || false;
                        this.dados[id] = this.dados[id] || {};
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar os territórios'
                    });
                });
        },

        removerTerritorio(id) {
            this.idsTerritoriosSelecionados.splice(
                this.idsTerritoriosSelecionados.indexOf(id),
                1
            );

            delete this.territorios[id];
            delete this.cardValido[id];
            delete this.dados[id];

            this.atualizarerritoriosSelecionados();
            this.testeFinalizar();
        },

        changeShowModalAddTerritorios() {
            this.atualizarerritoriosSelecionados();
            this.showModalAddTerritorios = !this.showModalAddTerritorios;
        },

        setValidacao({ valido, id }) {
            this.cardValido[id] = valido;
            this.testeFinalizar();
        },

        testeFinalizar() {
            let finalizar = true;

            for (const id in this.cardValido) {
                if (this.cardValido[id] === false) {
                    finalizar = false;
                    break;
                }
            }

            this.finalizar = finalizar;
        },

        setDados(dados) {
            this.dados[dados.id] = dados;
            this.dados[dados.id].editado = dados.editado;
        },

        async solicitarRelatorios() {
            const idsterritorios = [];
            let isError = false;
            for (const id in this.cardValido) {
                if (this.dados[id].editado === true) {
                    let response = await this.updateTerritorio(this.dados[id]);
                    if (!response) {
                        isError = true;
                        break;
                    }
                }
                idsterritorios.push(this.dados[id].id);
            }
            if (isError) {
                idsterritorios.splice(0, idsterritorios.length);
                this.$notify.error({
                    message:
                        'Ocorreu um erro durante a atualização dos dados. Tente novamente.'
                });
            } else {
                let resp =
                    await CompartilhamentoDadosService.cadastrarCompartilhamentoDados(
                        { territoriosIds: idsterritorios }
                    );
                if (resp.status === 200) {
                    this.$notify.success({
                        message:
                            'Relatório solicitado com sucesso. O processamento está em andamento e os resultados ficarão disponíveis na listagem de relatórios.'
                    });
                    this.$router.go(-1);
                } else {
                    this.$notify.error({
                        message: 'Não foi possivel solicitar o relatório.'
                    });
                }
            }
        },

        addTerritorios(territorios) {
            this.idsTerritoriosSelecionados = territorios;
            this.getTerritorios();
            this.changeShowModalAddTerritorios();
        },

        atualizarerritoriosSelecionados() {
            this.territoriosSelecionados = [];

            for (const id in this.territorios) {
                this.territoriosSelecionados.push(this.territorios[id]);
            }
        },
        async updateTerritorio(territorio) {
            const updateData = {
                comercializacoes: territorio.comercializacoes,
                id: territorio.id
            };

            const result = await TerritorioService.updateComercializacoes(
                updateData
            );

            return result.status === 200;
        },
        validacaoIcorreta() {
            this.$notify.error({
                message:
                    'Dados incompletos! Favor revise os campos de Comercialização.'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#solicitar-laudos {
    .territorios {
        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .m-titulo {
            margin-top: 25px;
            margin-bottom: 25px;
        }

        .sem-territorios {
            display: flex;
            align-items: center;
            justify-content: center;

            height: 400px;

            a {
                text-decoration: underline;
            }

            a:hover {
                cursor: pointer;
            }
        }
    }

    .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
